// @ts-nocheck
/* eslint-disable */
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
 
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
 
 
 
import React, { useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import {
  createStyles,
  Grid,
  makeStyles,
  Table,
  Button,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import DownloadIcon from '@mui/icons-material/Download';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import ClearIcon from '@mui/icons-material/Clear';
import qs from 'qs';

import moment from 'moment';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { getTripSales } from 'actions';
import { CardTitle } from 'app/components/shared/card-title';
import { DataTableContainer } from 'app/components/shared/data-table-container';
import { LoadingSpinner } from 'app/components/shared/loading-spinner';
import { TextCell } from 'app/components/shared/table';
import { SystemEmptyState } from 'app/components/system-empty-state';
import { basicButtonStyles, tableRowStyles } from 'app/shared/styles';
import { LanguageContext } from 'context/intl.context';
import { splitValues, trimTrailingSlash, useTypedSelector } from 'helpers';
import { TripSale } from 'types';
import biimg from "./Power-BI-Logo.png";
import { toast } from 'react-toastify';
import { FilterTripSale } from './filter-trip-sale';
import { TripSalesFilterParams } from './filters';
import {
  PaginationComponent,
  usePagination,
} from '../../components/use-pagination';
const useStyles = makeStyles(() =>
  createStyles({
    table: { minWidth: 750, overflow: 'scroll', whiteSpace: 'nowrap' },
    addButton: { ...basicButtonStyles },
    row: { ...tableRowStyles },
  })
);

const TripSaleListItem = ({ tripSale }: { tripSale: TripSale }) => {
  const classes = useStyles();
  const intl = useIntl();

  const isOfflineLabel =
    tripSale.is_offline === true
      ? intl.formatMessage({ id: 'offline' }) || 'Offline'
      : tripSale.is_offline === false
      ? intl.formatMessage({ id: 'online' }) || 'Online'
      : '—';

  return (
    <TableRow className={classes.row}>
      <TextCell
        label={tripSale.axis_code}
        align="center"
        style={{ fontFamily: 'Cairo' }}
      />

      <TextCell
        label={tripSale.ticket_serial}
        align="center"
        style={{ fontFamily: 'Cairo' }}
      />

      <TextCell label={tripSale?.vehicle_code} />

      <TextCell
        label={`${tripSale.driver_username || ''} ${
          tripSale.driver_name || ''
        }`}
      />

      <TextCell
        label={moment(tripSale.created_at).format('DD/MM/YYYY HH:mm:ss')}
        align="center"
      />

      <TextCell label={String(tripSale.amount_after_discount ?? '')} align="center" />
      <TextCell label={String(tripSale.price ?? '')} align="center" />
      <TextCell label={String(tripSale.discount_applied ?? '')} align="center" />
      <TextCell label={tripSale.discount_band_code || ''} align="center" />
      <TextCell
        label={tripSale.obc_time ? moment(tripSale.obc_time).format('DD/MM/YYYY HH:mm:ss') : ''}
        align="center"
      />

      <TextCell label={isOfflineLabel} align="center" />
    </TableRow>
  );
};

const TripSaleList: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [isSearching, setSearching] = useState(false);
  const [isFiltering, setFiltering] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [filterParams, setFilterParams] = useState<Record<string, string>>({});
  const [sortBy, setSortBy] = useState<string>('created_at');
  const [sortOrder, setSortOrder] = useState<'ASC'|'DESC'>('DESC');

  const { direction } = useContext(LanguageContext);

  const tripSaleListIsLoading = useTypedSelector(
    state => state.tripSales.isLoading as boolean
  );

  const tripSaleListHasError = useTypedSelector(
    state => state.tripSales.hasError
  );

  const tripSalesTotalCount = useTypedSelector(
    state => state.tripSales.totalCount
  );

  const tripSaleList = useTypedSelector(state => {
    if (!state.tripSales.isLoading && Object.values(state.tripSales).length) {
      return Object.values(state.tripSales.collection);
    }

    return [];
  });

  const fetchSearchResults = useCallback(
    (page: number, rowSize: number) =>
      getTripSales(page, rowSize, { q: { ticket_serial_cont: searchTerm }, sortBy, sortOrder }),
    [searchTerm, sortBy, sortOrder]
  );

    const fetchFilterResults = useCallback(
    (page: number, rowSize: number) => {
      const { driver, axis, vehicle, minDate, maxDate, minDateObc, maxDateObc, discountBandCode, discountBandAssignments, isOffline } = TripSalesFilterParams;

      return getTripSales(page, rowSize, {
        group_ids: filterParams.groups as unknown as string[],
        sortBy,
        sortOrder,
        q: {
          [driver]: splitValues(filterParams[driver]),
          [axis]: splitValues(filterParams[axis]),
          [vehicle]: splitValues(filterParams[vehicle]),
          [minDate]: filterParams[minDate],
          [maxDate]: filterParams[maxDate],
          [minDateObc]: filterParams[minDateObc],
          [maxDateObc]: filterParams[maxDateObc],
          [discountBandCode]: splitValues(filterParams[discountBandCode]),
          [discountBandAssignments]: filterParams[discountBandAssignments],
          [isOffline]: filterParams[isOffline],
        },
      });
    },
    [filterParams, sortBy, sortOrder]
  );

  const fetchDefaultResults = useCallback(
    (page: number, rowSize: number) => getTripSales(page, rowSize, { sortBy, sortOrder }),
    [sortBy, sortOrder]
  );

  const fetchAction = useCallback(() => {
    if (isSearching) return fetchSearchResults;

    if (isFiltering) return fetchFilterResults;

    return fetchDefaultResults;
     
  }, [fetchFilterResults, fetchSearchResults, fetchDefaultResults, isFiltering, isSearching]);

  const { rowsPerPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ fetchAction: fetchAction() });

  const resetPageState = () => {
    handleChangePage(null, 0);
  };

  const handleExport = async () => {
    setIsExporting(true);
    let queryParams: any = { sortBy, sortOrder };

    if (isSearching && searchTerm) {
      queryParams = { q: { ticket_serial_cont: searchTerm } };
    } else if (isFiltering) {
      const { driver, axis, vehicle, minDate, maxDate, minDateObc, maxDateObc, discountBandCode, discountBandAssignments, isOffline } = TripSalesFilterParams;
      queryParams = {
        group_ids: filterParams.groups as unknown as string[],
        q: {
          [driver]: splitValues(filterParams[driver]),
          [axis]: splitValues(filterParams[axis]),
          [vehicle]: splitValues(filterParams[vehicle]),
          [minDate]: filterParams[minDate],
          [maxDate]: filterParams[maxDate],
          [minDateObc]: filterParams[minDateObc],
          [maxDateObc]: filterParams[maxDateObc],
          [discountBandCode]: splitValues(filterParams[discountBandCode]),
          [discountBandAssignments]: filterParams[discountBandAssignments],
          [isOffline]: filterParams[isOffline],
        },
      };
    }

    try {
      let userAuthData = null;
      const localAuthData = localStorage.getItem('authData');
      if (localAuthData) {
        const parsedAuthData = JSON.parse(localAuthData);
        userAuthData = parsedAuthData.userToken;
      }

      toast.info(intl.formatMessage({ id: 'ExportingPleaseWait' }) || 'Exporting data...');

      const baseUrl = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/financialControl/tripSales/export_tickets`;
      
      const res = await axios.get(baseUrl, {
        params: { ...queryParams, fileType: 'xlsx' },
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' }),
        headers: {
          'access-token': userAuthData?.['access-token'] || userAuthData?.access_token,
          'uid': userAuthData?.uid,
          'client': userAuthData?.client,
          'Authorization': `Bearer ${  localStorage.getItem('dashboard_token')}`,
        },
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `TripSales_Export_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error('Export error', error);
      toast.error(intl.formatMessage({ id: 'ExportFailed' }) || 'Export Failed');
    } finally {
      setIsExporting(false);
    }
  };

  const filterTripSales = (filters: Record<string, string>) => {
    if (Object.values(filters)?.length) {
      setFiltering(true);
      setSearching(false);
      setSearchTerm('');
    }

    resetPageState();

    setFilterParams(filters);
  };

  const handleSearch = () => {
    if (searchTerm) {
      dispatch(
        getTripSales(page, rowsPerPage, {
          q: { ticket_serial_cont: searchTerm },
          sortBy,
          sortOrder
        })
      );

      setSearching(true);
    } else {
      setSearching(false);
    }

    resetPageState();
  };

  const handleSortColumn = (field: string) => {
    if (sortBy === field) {
      setSortOrder(prev => prev === 'DESC' ? 'ASC' : 'DESC');
    } else {
      setSortBy(field);
      setSortOrder('DESC');
    }
    resetPageState();
  };

  const handleResetSort = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSortBy('created_at');
    setSortOrder('DESC');
    resetPageState();
  };

  const renderSortIcon = (field: string) => {
    const isActive = sortBy === field;
    if (!isActive) {
      return <UnfoldMoreIcon style={{ fontSize: '20px', verticalAlign: 'middle', opacity: 0.4, marginLeft: '4px', strokeWidth: 1 }} />;
    }
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        {sortOrder === 'ASC'
          ? <ArrowUpwardIcon style={{ fontSize: '20px', verticalAlign: 'middle', color: '#1976d2', marginLeft: '4px', strokeWidth: 1.5, stroke: '#1976d2' }} />
          : <ArrowDownwardIcon style={{ fontSize: '20px', verticalAlign: 'middle', color: '#1976d2', marginLeft: '4px', strokeWidth: 1.5, stroke: '#1976d2' }} />
        }
        <ClearIcon 
          onClick={handleResetSort} 
          style={{ fontSize: '18px', color: 'black', marginLeft: '6px', cursor: 'pointer', border: '1px solid gray', borderRadius: '3px', padding: '1px' }} 
          titleAccess="Reset Sort" 
        />
      </span>
    );
  };

  const Pagination = () => (
    <PaginationComponent
      {...{
        totalCount: tripSalesTotalCount,
        hasData: !!tripSaleList.length,
        rowsPerPage,
        page,
        handleChangePage,
        handleChangeRowsPerPage,
      }}
    />
  );

     /* useEffect(()=>{
        console.log(JSON.stringify(tripSaleList));
      },[tripSaleList])*/
      // Function to remove duplicates based on ticket_serial

  return (
    <div dir={direction}>
      <CardTitle title={intl.formatMessage({ id: 'tripSales' })}>
        <button 
           className={classes.addButton} 
           onClick={handleExport} 
           disabled={isExporting} 
           style={{ backgroundColor: '#0daa6e', color: 'white', border: 'none', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px' }}
        >
           <DownloadIcon style={{ marginRight: direction === 'rtl' ? '0px' : '5px', marginLeft: direction === 'rtl' ? '5px' : '0px', fontSize: '20px' }} />
           {isExporting ? (intl.formatMessage({ id: 'ExportingPleaseWait' }) || 'Exporting...') : (intl.formatMessage({ id: 'export' }) || 'Export')}
        </button>
      </CardTitle>

      <Grid container style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        
      
   
        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
          <FilterTripSale
            {...{
              searchTerm,
              setSearchTerm,
              handleSearch,
              showFilters: !!tripSaleList.length && !isSearching,
              filterTripSales,
              isSearching,
            }}
          />
        </Grid>
      
        <Grid
          item
          style={{
            flex: 1,
            justifyContent: 'flex-end',
            alignSelf: 'flex-end',
          }}
        >
          <Pagination />
        </Grid>
      </Grid>

      <DataTableContainer
        alignItems={tripSaleListIsLoading ? 'center' : 'flex-start'}
      >
        {tripSaleListHasError ? (
          <Typography align="center" variant="h5" color="textSecondary">
            {intl.formatMessage({ id: 'somethingWrong' })}
          </Typography>
        ) : (
          <>
            {tripSaleListIsLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                {tripSaleList.length ? (
                  <Table
                    className={classes.table}
                    size="small"
                    aria-label="Trip Sale Table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" onClick={() => handleSortColumn('axis_code')} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
                          {intl.formatMessage({ id: 'axis' })}{renderSortIcon('axis_code')}
                        </TableCell>

                        <TableCell align="center" onClick={() => handleSortColumn('ticket_serial')} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
                          {intl.formatMessage({ id: 'code' })}{renderSortIcon('ticket_serial')}
                        </TableCell>

                        <TableCell align="center" onClick={() => handleSortColumn('vehicle_code')} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
                          {intl.formatMessage({ id: 'vehicle' })}{renderSortIcon('vehicle_code')}
                        </TableCell>

                        <TableCell align="center" onClick={() => handleSortColumn('driver_name')} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
                          {intl.formatMessage({ id: 'driver' })}{renderSortIcon('driver_name')}
                        </TableCell>

                        <TableCell align="center" onClick={() => handleSortColumn('created_at')} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
                          {intl.formatMessage({ id: 'createdAtDate' }) || 'Created At Date'}
                          {renderSortIcon('created_at')}
                        </TableCell>

                        <TableCell align="center" onClick={() => handleSortColumn('amount_after_discount')} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
                           {intl.formatMessage({ id: 'amountAfterDiscount' }) || 'Amt After Discount'}
                           {renderSortIcon('amount_after_discount')}
                        </TableCell>

                        <TableCell align="center" onClick={() => handleSortColumn('price')} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
                          {intl.formatMessage({ id: 'baseAmount' }) || 'Base Amount'}
                          {renderSortIcon('price')}
                        </TableCell>

                        <TableCell align="center" onClick={() => handleSortColumn('discount_applied')} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
                          {intl.formatMessage({ id: 'discountApplied' }) || 'Discount Applied'}
                          {renderSortIcon('discount_applied')}
                        </TableCell>

                        <TableCell align="center" onClick={() => handleSortColumn('discount_band_code')} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
                          {intl.formatMessage({ id: 'discountBandCode' }) || 'Discount Band'}
                          {renderSortIcon('discount_band_code')}
                        </TableCell>

                        <TableCell align="center" onClick={() => handleSortColumn('obc_time')} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
                          {intl.formatMessage({ id: 'obcTime' }) || 'OBC Time'}
                          {renderSortIcon('obc_time')}
                        </TableCell>

                        <TableCell align="center" style={{ userSelect: 'none', whiteSpace: 'nowrap' }}>
                          {intl.formatMessage({ id: 'isOffline' }) || 'Is Offline'}
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {tripSaleList.map(tripSale => (
                        <TripSaleListItem key={tripSale.id} {...{ tripSale }} />
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <div style={{ margin: 'auto auto' }}>
                    <SystemEmptyState
                      hasWriteAccess={false}
                      baseURL={baseURL}
                      showNote={false}
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
      </DataTableContainer>

      <Pagination />
    </div>
  );
};

export { TripSaleList };
